import deviceTypes from '@/store/types/deviceTypes';
import { Dispatch } from 'vuex';
import roles from '@/store/types/roles';

export default {
	namespaced: true,
	modules: {
		deviceTypes,
		roles,
	},
	actions: {
		async fetchAllTypes({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([dispatch('deviceTypes/fetchDeviceTypes'), dispatch('roles/fetchRoles')]);
		},

		cleanAllTypes({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('deviceTypes/cleanAllDeviceType');
			dispatch('roles/cleanRoles');
		},
	},
};
